import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructors-page-one',
  templateUrl: './instructors-page-one.component.html',
  styleUrls: ['./instructors-page-one.component.scss']
})
export class InstructorsPageOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
